import { render, staticRenderFns } from "./BrandMark.vue?vue&type=template&id=60b12cba&scoped=true&"
import script from "./BrandMark.vue?vue&type=script&lang=js&"
export * from "./BrandMark.vue?vue&type=script&lang=js&"
import style0 from "./BrandMark.vue?vue&type=style&index=0&id=60b12cba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b12cba",
  null
  
)

export default component.exports